<template>
  <v-btn @click.stop="onClick" text small>
    <v-icon id="RTE__command__redo">mdi-redo</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'redo',
  methods: {
    onClick () {
      this.$emit('click', 'redo')
    }
  }
}
</script>

<style scoped>
#RTE__command__redo {
  font-size: 20px;
}
</style>
